(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bunker-whey-campaign"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const storageKey = 'bunker-whey-poster-v1';
    const initialize = () => {
      document.querySelectorAll('[data-bunker-whey]').forEach((root) => {
        if (root.dataset.initialized) return;
        root.dataset.initialized = 'true';
        const popup = root.querySelector('.bunker-whey__popup');
        if (!popup) return;
        let timer;
        const remember = () => { try { sessionStorage.setItem(storageKey, '1'); } catch (_) {} };
        const dismiss = () => {
          clearTimeout(timer);
          const restoreFocus = popup.contains(document.activeElement);
          popup.hidden = true;
          remember();
          if (restoreFocus) root.querySelector('.bunker-whey__banner [data-whey-link]')?.focus({ preventScroll: true });
        };
        root.querySelectorAll('[data-whey-close]').forEach((button) => button.addEventListener('click', dismiss));
        root.querySelectorAll('[data-whey-link]').forEach((link) => link.addEventListener('click', () => { clearTimeout(timer); remember(); }));
        document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !popup.hidden) dismiss(); });
        let alreadyShown = false;
        try { alreadyShown = sessionStorage.getItem(storageKey) === '1'; } catch (_) { alreadyShown = true; }
        if (alreadyShown || root.dataset.popup !== 'true' || window.Shopify?.designMode) return;
        const show = () => {
          if (!root.isConnected) return;
          const modalOpen = [...document.querySelectorAll('dialog[open], [aria-modal="true"]:not([hidden])')].some((element) => !element.closest('details:not([open])') && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden');
          if (document.hidden || modalOpen) {
            timer = setTimeout(show, 2000);
            return;
          }
          popup.hidden = false;
          remember();
        };
        timer = setTimeout(show, Number(root.dataset.delay) || 8000);
        document.addEventListener('shopify:section:unload', (event) => {
          if (event.target.contains(root)) clearTimeout(timer);
        }, { once: true });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
    document.addEventListener('shopify:section:load', initialize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
